import React, { Component } from "react";
import Related from "./related";

class RelatedComponent extends Component {
  constructor(props) {
    super(props);
  }

  componentDidCatch(error) {
    /* eslint-disable-next-line */
    console.log(error);
  }

  render() {
    return (
      <div>
        <Related api={this.props} />
      </div>
    );
  }
}

export default RelatedComponent;
